import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import MarkdownRender from 'LuxKit/MarkdownRender'
import BodyText from 'LuxKit/Typography/BodyText'

const DetailsDescription = styled(MarkdownRender)`
  margin-top: ${rem(12)};
`

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
`

const Section = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(8)};
`

interface Props {
  pkg: App.Package
}

function RoomDetails(props: Props) {
  const { pkg } = props

  return (
    <Container>
      <Section>
        <BodyText variant="medium" weight="bold">
          Room facilities:
        </BodyText>
        {pkg.roomType?.amenities.map((amenity) => (
          <BodyText as="li" variant="small" key={amenity.id}>
            {amenity.description}
          </BodyText>
        ))}
      </Section>
      {pkg.roomPolicyDescription && (
        <Section>
          <BodyText variant="medium" weight="bold">
            Room policies:
          </BodyText>
          <DetailsDescription
            fontSize="medium"
            content={pkg.roomPolicyDescription}
            type="compact"
          />
        </Section>
      )}
    </Container>
  )
}

export default React.memo(RoomDetails)
